/** 商品SPU管理API */
import type { Api } from '@/typings/api';
import { post, upload } from '../../request';
const prefix = '/base/productSpu';
/**
 * 分页查询商品SPU管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.ProductSpu> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询商品SPU管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.ProductSpu> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个商品SPU管理
 *
 * @param id 商品SPU管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.ProductSpu> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存商品SPU管理
 *
 * @param params 商品SPU管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新商品SPU管理信息
 *
 * @param params 商品SPU管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除商品SPU管理
 *
 * @param id 商品SPU管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除商品SPU管理
 *
 * @param ids 商品SPU管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doImport
};
